import type { ActionType } from "typesafe-actions";
import { createReducer } from "typesafe-actions";

import type { IntentState } from "../../../types/common";
import * as ac from "../actions/actions";

export const INITIAL_INTENT_STATE: IntentState = {
    isCategoriesFetching: false,
    isCategoriesFetched: false,
    categoryFetchError: undefined,
    isSelectedTopicsFetching: false,
    isSelectedTopicsFetched: false,
    selectedTopicsFetchError: undefined,
    isUserApprovedTerms: false,
    isUserApprovedTermsFetched: false,
    categories: [],
    countries: [],
    createdAt: undefined,
    selectedTopics: [],
};

const intentReducer = createReducer<IntentState, ActionType<typeof ac>>(INITIAL_INTENT_STATE)
    .handleAction(
        ac.fetchIntentCategories.request,
        (state): IntentState => ({
            ...state,
            isCategoriesFetching: true,
            isCategoriesFetched: false,
        }),
    )
    .handleAction(
        ac.fetchIntentCategories.failure,
        (state, { payload }): IntentState => ({
            ...state,
            isCategoriesFetching: false,
            isCategoriesFetched: false,
            categoryFetchError: payload,
        }),
    )
    .handleAction(
        ac.fetchIntentCategories.success,
        (state, { payload }): IntentState => ({
            ...state,
            isCategoriesFetching: false,
            isCategoriesFetched: true,
            categories: payload.categories,
            countries: payload.countries,
        }),
    )
    .handleAction(
        ac.fetchSelectedIntentTopics.request,
        (state): IntentState => ({
            ...state,
            isSelectedTopicsFetching: true,
            isSelectedTopicsFetched: false,
        }),
    )
    .handleAction(
        ac.fetchSelectedIntentTopics.success,
        (state, { payload }): IntentState => ({
            ...state,
            selectedTopics: payload.topics || [],
            createdAt: new Date(payload.createdAt),
            isSelectedTopicsFetching: false,
            selectedTopicsFetchError: undefined,
        }),
    )
    .handleAction(
        ac.fetchSelectedIntentTopics.failure,
        (state, { payload }): IntentState => ({
            ...state,
            isSelectedTopicsFetching: false,
            selectedTopicsFetchError: payload,
            selectedTopics: [],
            createdAt: undefined,
        }),
    )
    .handleAction(
        ac.fetchIntentUserApproval.request,
        (state): IntentState => ({
            ...state,
            isUserApprovedTerms: false,
            isUserApprovedTermsFetched: false,
        }),
    )
    .handleAction(
        ac.fetchIntentUserApproval.success,
        (state, { payload }): IntentState => ({
            ...state,
            isUserApprovedTerms: payload.isApproved,
            isUserApprovedTermsFetched: true,
        }),
    )
    .handleAction(
        ac.fetchIntentUserApproval.failure,
        (state): IntentState => ({
            ...state,
            isUserApprovedTerms: false,
        }),
    )
    .handleAction(
        ac.saveIntentUserApproval.failure,
        (state): IntentState => ({
            ...state,
            isUserApprovedTerms: false,
        }),
    )
    .handleAction(
        ac.saveIntentUserApproval.success,
        (state): IntentState => ({
            ...state,
            isUserApprovedTerms: true,
        }),
    );

export default intentReducer;
